export default __webpack_public_path__ + "static/media/Chichen Itza.03a719bb.svg";